export const isEmail = (value) => {
  const validEmail =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // NOSONAR
  return !validEmail.test(value)
}

export const isEmptyOrWhiteSpace = (str) => {
  const regex = /^\s*$/
  return regex.test(str)
}
